function init() {
    if (typeof productJSON === 'undefined') return;

    const productForms = document.querySelectorAll('[action^="/cart/add"]');

    productForms.forEach(form => {
      const sellingPlanContainer = document.createElement("input");
      sellingPlanContainer.id = "selling_plan";
      sellingPlanContainer.className = "gsa_selling_plan";
      sellingPlanContainer.type = "hidden";
      sellingPlanContainer.setAttribute("name", "selling_plan");
      sellingPlanContainer.value = "";

      form.appendChild(sellingPlanContainer.cloneNode());
    });

    const activeCurrency = Shopify.currency.active;

    const currencyToLocaleMap = {
      'USD': 'en-US', 'EUR': 'fr-FR', 'GBP': 'en-GB', 'CAD': 'en-CA',
      'AUD': 'en-AU', 'JPY': 'ja-JP', 'CNY': 'zh-CN', 'HKD': 'zh-HK',
      'NZD': 'en-NZ', 'CHF': 'de-CH', 'ZAR': 'en-ZA', 'SEK': 'sv-SE',
      'NOK': 'nb-NO', 'DKK': 'da-DK', 'INR': 'en-IN', 'SGD': 'en-SG',
      'MXN': 'es-MX', 'BRL': 'pt-BR', 'RUB': 'ru-RU', 'PLN': 'pl-PL',
      'PHP': 'en-PH', 'TRY': 'tr-TR', 'THB': 'th-TH', 'MYR': 'ms-MY',
      'IDR': 'id-ID', 'TWD': 'zh-TW', 'VND': 'vi-VN', 'KRW': 'ko-KR', 'AED': 'ar-AE'
    };

    const locale = currencyToLocaleMap[activeCurrency] || 'en-US';

    const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: activeCurrency,
    });

    let lastSubscriptionPosition = 0;

    // @stayai — resolve the active subscription app's group so only its plans
    // drive pricing and the hidden selling_plan cart input. ACTIVE_APP_ID is set
    // on <selling-plan-selector data-active-app-id> in product-block-gsa-subscription.liquid.
    // Compare app_id as a STRING (Recharge '294517', Stay '5859381', and some
    // vendors use non-numeric ids) — never parseInt it.
    const getActiveAppId = () => {
        const el = document.querySelector("selling-plan-selector");
        return el && el.dataset.activeAppId ? String(el.dataset.activeAppId) : null;
    };
    const getActiveGroup = (productData) => {
        const groups = (productData && productData.selling_plan_groups) || [];
        const appId = getActiveAppId();
        if (!appId) return groups[0]; // no switch present → legacy behavior
        return groups.find((g) => String(g.app_id) === appId) || null;
    };

    const mapSellingPlan = (currentVariantId, subscriptionPosition) => {
        const onetimePrice = document.getElementById("one-time-price");
        if (!onetimePrice) return;

        const productData = productJSON;
        const productVariants = productData.variants;
        const onetimeFilterPrice = productVariants.find(p => p.id === parseInt(currentVariantId));
        if (!onetimeFilterPrice) return;

        onetimePrice.innerHTML = formatter.format((onetimeFilterPrice.price / 100).toFixed(2));

        if (subscriptionPosition === null) {
            updateSubscriptionPrice(productData, lastSubscriptionPosition);
        } else {
            lastSubscriptionPosition = subscriptionPosition;
            updateSubscriptionPrice(productData, lastSubscriptionPosition);
        }
    }
 
    const updateSubscriptionPrice = (productData, lastSubscriptionPosition) => {
        const subscriptionPrice = document.getElementById("subscription-price");
        if (!subscriptionPrice) return;

        const activeGroup = getActiveGroup(productData);
        if (!activeGroup) return;
        const currentSellingPlanId = activeGroup.selling_plans[lastSubscriptionPosition].id;
        const currentVariant = productData.variants.find(p => p.id === parseInt(currentVariantId));
        if (!currentVariant) return;

        const subscriptionFilterPrice = currentVariant.selling_plan_allocations.find(p => p.selling_plan_id === parseInt(currentSellingPlanId));
        if (!subscriptionFilterPrice) return;

        subscriptionPrice.innerHTML = formatter.format((subscriptionFilterPrice.price / 100).toFixed(2));
    }
 
    class SellingPlan extends HTMLElement {
        constructor() {
            super();
            this.addEventListener("change", this.onSellingPlanChange);
            window.addEventListener("load", this.initialLoad);
        }
 
        initialLoad() {
            const variantElement = document.querySelector("selling-plan-selector");        
            const boundHandlePageLoad = handlePageLoad.bind(variantElement);
            boundHandlePageLoad();
            function handlePageLoad() {
                this.onSellingPlanChange();
            }
        }
 
        onSellingPlanChange() {
            this.updateSellingPlan();
            this.updateSellingPlanID();
            this.updatePurchaseOptionUI();
        }
 
        getSubscriptionJSON() {
            this.subscriptionData = this.subscriptionData || productJSON;
            return this.subscriptionData;
        }
 
        updateSellingPlan() {
            let variantSelector = document.querySelector('[name="id"]');
            let selectedVariantId = variantSelector.value;
 
            this.getSubscriptionJSON();
 
            const fieldsets = Array.from(this.querySelectorAll('#subscription-frequency-fieldset'));
            this.subscriptionFrequency = fieldsets.map((fieldset) => {
                return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
            });
            const activeGroup = getActiveGroup(this.subscriptionData);
            let currentSellingGroup = activeGroup ? activeGroup.selling_plans : [];

            const names = [];
            for (let i = 0; i < currentSellingGroup.length; i++) {
                names.push(currentSellingGroup[i].name);
            }
 
            // console.log(this.subscriptionFrequency);
            // console.log(names);
 
           
            this.subscriptionPosition = names.indexOf(this.subscriptionFrequency[0]);
            this.currentSellingPlanID = (activeGroup && this.subscriptionPosition > -1)
                ? activeGroup.selling_plans[this.subscriptionPosition].id
                : "";
        }
 
        updateSellingPlanID() {
            const subscriptionSelected = document.getElementById("subscription-option").checked;
            const sellingPlanContainers = document.querySelectorAll("#selling_plan");
           
            sellingPlanContainers.forEach(container => {
              if (subscriptionSelected) {
                container.value = this.currentSellingPlanID;
              } else {
                container.value = "";
              }
            });
            this.updateMappingLogic();
        }
 
        updateMappingLogic() {
            let subscriptionPosition = this.subscriptionPosition;
            const boundHandlePageLoadTest = handlePageLoadTest.bind(window);
            boundHandlePageLoadTest();
            function handlePageLoadTest() {
                mapSellingPlan(currentVariantId, subscriptionPosition);
            }
        }
 
        updatePurchaseOptionUI() {
            const subscriptionFequency = document.getElementById("subscription-frequency-fieldset");
            const subscriptionOptionEl = document.getElementById("subscription-option");
            if (!subscriptionFequency || !subscriptionOptionEl) return;

            const subscriptionSelected = subscriptionOptionEl.checked;
            const accordionContent = document.getElementsByClassName("gsa-accordion-content")[0];
            const firstObjectionBuster = document.getElementById("gsa-first-objection-buster");
            const secondObjectionBuster = document.getElementById("gsa-second-objection-buster");

            if (subscriptionSelected === true) {
                this.subscriptionIsSelected = true;
                subscriptionFequency.style.display = "block";
                if (accordionContent) accordionContent.classList.add('open');
                if (firstObjectionBuster) {
                  firstObjectionBuster.style.display = "block";
                  if (secondObjectionBuster) secondObjectionBuster.style.display = "none";
                }
            } else {
                this.subscriptionIsSelected = false;
                subscriptionFequency.style.display = "none";
                if (accordionContent) accordionContent.classList.remove('open');
                if (firstObjectionBuster) {
                  firstObjectionBuster.style.display = "none";
                  if (secondObjectionBuster) secondObjectionBuster.style.display = "block";
                }
            }
        }
 
 
        updateFrequencyUI() {
            let tabIndicator = document.getElementsByClassName('frequency_tab-indicator')[0];
            let frequencyOptions = document.querySelectorAll('.frequency_purchase_options .frequency_purchase_options_label');
            let tabHeader = document.getElementsByClassName('frequency_purchase_options')[0];
            tabIndicator.style.width = `calc(100% / ${frequencyOptions.length})`;
            let frequencyInputs = document.getElementsByName('Deliver every');
            for(let x = 0; x < frequencyInputs.length; x++) {
                if(frequencyInputs[x].checked) {
                    // console.log(frequencyInputs[x]);
                    tabIndicator.style.left = `calc(calc(100% / ${frequencyOptions.length}) * ${x})`;
                }
            }
 
        }
 
 
    }
 
    customElements.define("selling-plan-selector", SellingPlan);

        let variantSelector = document.querySelector('[name="id"]');
        let currentVariantId = variantSelector.value;

        document.addEventListener('shapes:product:variantchange', function(e) {
            const newVariantId = e.detail.variant.id.toString();
            if (newVariantId !== currentVariantId) {
                currentVariantId = newVariantId;
                mapSellingPlan(currentVariantId, null);
            }
        });
    }

    if (document.readyState === "loading") {
       document.addEventListener("DOMContentLoaded", init);
    } else {
      init();
    }